// @flow

// DOMException spec: https://heycam.github.io/webidl/#idl-DOMException
// NOTE This is a hyper-minimal typedef for it
declare class DOMException {
  +name: string;
}

export function isAbortError(error: mixed) {
  return error instanceof DOMException && error.name === 'AbortError';
}
